import React from "react";
import CheckWhiteIcon from "../../common/images-new/check-white-icon.svg"
import UncheckWhiteIcon from "../../common/images-new/uncheck-white-icon.svg"
import { TextBlack, TextGray, TextGreen } from "../../pages/Theme";

const Toggle = ({ checked, onChange }) => {
    return (
        <div className="flex flex-row items-center justify-center">
            <label className="flex items-center cursor-pointer" >
                <div className="relative">
                    <input type="checkbox"
                        className="sr-only"
                        checked={checked}
                        onChange={onChange} />
                    <div className="block checkGreen checkColorGreen w-14 h-7 border rounded-full 
                                    flex flex-row
                                    items-center justify-center">
                        {/* <img className="mr-3" src={CheckWhiteIcon} alt="check icon"></img>
                        <img src={UncheckWhiteIcon} alt="uncheck icon"></img> */}
                    </div>
                    <div className={`dot absolute top-0 w-5 h-5 mt-1 rounded-full transition ${checked ? "right-6 bg-white" : "ml-1 lightBackGroundColor"}`}></div>
                </div>
            </label>
        </div>
    )
}

export default Toggle
